export enum TopicName {
  all = "all",
  page = "page",
  org = "org",
  recommend = "recommend",
  help = "help",
  member = "member",
  role = "role",
  assessment = "assessment",
  setting = "setting",
}
